<template>
  <RouterView />
</template>
<script setup lang="ts"></script>
<style scoped></style>
